import { FC } from "react";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { AttachmentsFilterEnum } from "constants/filters/attachments-filter";

import { IFilterConfig } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

interface IProps {
  filterValues: AttachmentsFilterEnum[];
  filterConfig: IFilterConfig;
  onChange(selectedItem: { name: string; value: [string] | null }): void;
  onClose(): void;
}

export const AttachmentsFilterLabels = {
  [AttachmentsFilterEnum.Yes]: "Has attachments",
  [AttachmentsFilterEnum.No]: "Has no attachments",
};

const items = [AttachmentsFilterEnum.Yes, AttachmentsFilterEnum.No].map(value => ({
  key: value,
  name: AttachmentsFilterLabels[value],
}));

const AttachmentsFilter: FC<IProps> = props => {
  const { onChange, filterValues, onClose } = props;
  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    onChange({ name: Filter.Attachments, value: selectedItem !== null ? [selectedItem[0].key] : null });
    onClose();
  };
  const selected = filterValues?.includes(AttachmentsFilterEnum.Yes) ? [items[0]] : [items[1]];

  return (
    <Picker
      id="attachments-filter"
      hideClearButton
      openedOnInit
      options={items}
      selected={filterValues ? selected : null}
      onSelect={handleChange}
      searchDisabled
    />
  );
};

export default withFilterBase(AttachmentsFilter);
